import React, { useEffect, useState } from 'react';
import {
  getCountry, getDomain, getHeight, getMaritualStatus, getCast, getCity,
  getState, getReligion, getEducation, getOccupation, getProfileById, getAllReligion,
  getAllIncome,
  getSearch,
  getReligionByIds,
  getCasteByIds,
  getMultipleState,
  getMultipleCity
} from '../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, TextField, Checkbox, ListItemText } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../services/firebaseConfig';

export const Search = () => {
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [country, setCountry] = useState([]);
  const [height, setHeight] = useState([]);
  const [religion, setReligion] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [education, setEducation] = useState([]);
  const [income, setIncome] = useState([]);
  const [domain, setDomain] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [castList, setCastList] = useState([]);
  const navigate = useNavigate();
  const [profileId, setProfileId] = useState('');
  const [selectedCriteria, setSelectedCriteria] = useState({});
  const [page, setPage] = useState(1);
  const indiaId = 233;
  const gender = localStorage.getItem('gender');

  const initialValues = {
    domain: '',
    city: '',
    state: '',
    country: indiaId,
    income: '',
    cast: '',
    religion: '',
    citizenship: indiaId,
    maritalStatus: [],
    // tokan: localStorage.getItem('token'),
    user_id: localStorage.getItem('user_id'),
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          maritalResponse, heightResponse, countryResponse, domainResponse,
          educationResponse, occupationResponse, religionResponse, incomeResponse
        ] = await Promise.all([
          getMaritualStatus(),
          getHeight(),
          getCountry(),
          getDomain(),
          getEducation(),
          getOccupation(),
          getAllReligion(),
          getAllIncome(),
        ]);
        setMaritalStatus(maritalResponse.data);
        setHeight(heightResponse.data);
        setCountry(countryResponse.data.data);
        setDomain(domainResponse.data.data);
        setEducation(educationResponse.data.data);
        setOccupation(occupationResponse.data.data);
        setReligion(religionResponse.data);
        setIncome(incomeResponse.data.data);
      } catch (error) {
        toast.error('Error Fetching Data:', error);
      }
    };
    fetchData();
  }, []);

  console.log(selectedCriteria)

  useEffect(() => {
    if (initialValues.country) {
      fetchState(initialValues.country);
    }
  }, [initialValues.country]);

  useEffect(() => {
    if (initialValues.state) {
      fetchCity(initialValues.state);
    }
  }, [initialValues.state]);

  const fetchState = async (country_id) => {
    try {
      const response = await getMultipleState({ ids: country_id });
      setStateList(response.data);
    } catch (error) {
      console.error('Error fetching State:', error);
    }
  };

  const fetchCity = async (state_id) => {
    try {
      const response = await getMultipleCity({ ids: state_id });
      setCityList(response.data);
    } catch (error) {
      console.error('Error fetching City:', error);
    }
  };

  const fetchReligion = async (Domain_id) => {
    try {
      const response = await getReligionByIds({ ids: Domain_id });
      setReligionList(response.data);
    } catch (error) {
      console.error('Error fetching Religion:', error);
    }
  };

  const fetchCast = async (religion_id) => {
    try {
      const response = await getCasteByIds({ ids: religion_id });
      setCastList(response.data);
    } catch (error) {
      console.error('Error fetching Caste:', error);
    }
  };

  const handleCountryChange = (event, value) => {
    if (value) {
      const country_id = value.map(item => item.value);
      initialValues.country = country_id;
      initialValues.state = '';
      initialValues.city = '';
      fetchState(country_id);
    } else {
      initialValues.country = '';
      initialValues.state = '';
      initialValues.city = '';
    }
  };


  const handleStateChange = (event, value) => {
    const state_id = value.map(item => item.value);
    initialValues.state = state_id;
    initialValues.city = '';
    fetchCity(state_id);
  };

  const handleDomainChange = (event, value) => {
    const Domain_id = value.map(item => item.value);
    initialValues.domain = Domain_id;
    initialValues.religion = '';
    initialValues.cast = '';
    fetchReligion(Domain_id);
  };

  const handleReligionChange = (event, value) => {
    const religion_id = value.map(item => item.value);
    initialValues.religion = religion_id;
    initialValues.cast = '';
    fetchCast(religion_id);
  };

  const handleProfileSearch = async (profileId) => {
    try {
      logEvent(analytics, "view_profile", {
        viewed_profile_id: profileId,
        profile_viewer_id: localStorage.getItem('user'),
        timestamp: new Date().toISOString(),
      })
      navigate('/profile-view', { state: { user_id: profileId } });
    } catch (error) {
      toast.error('Something Went Wrong:', error);
    }
  };

  const handleSearch = async () => {
    try {
      const formattedCriteria = {};
      // Convert selected criteria to the required format
      if (selectedCriteria.ageMin) {
        formattedCriteria.ageFrom = selectedCriteria.ageMin;
      }
      if (selectedCriteria.ageMax) {
        formattedCriteria.ageTo = selectedCriteria.ageMax;
      }
      if (selectedCriteria.heightMin) {
        formattedCriteria.partnerHeightFrom = selectedCriteria.heightMin.id;
      }
      if (selectedCriteria.heightMax) {
        formattedCriteria.partnerHeightTo = selectedCriteria.heightMax.id;
      }
      if (selectedCriteria.maritalStatus && selectedCriteria.maritalStatus.length > 0) {
        formattedCriteria["maritalStatus"] = selectedCriteria.maritalStatus;
      }
      if (selectedCriteria.country && selectedCriteria.country.length > 0) {
        formattedCriteria["country"] = selectedCriteria.country.map(item => item.value);
      }

      if (selectedCriteria.state && selectedCriteria.state.length > 0) {
        formattedCriteria["state"] = selectedCriteria.state.map(item => item.value);
      }
      if (selectedCriteria.city && selectedCriteria.city.length > 0) {
        formattedCriteria["city"] = selectedCriteria.city.map(item => item.value);
      }
      if (selectedCriteria.motherTongue && selectedCriteria.motherTongue.length > 0) {
        formattedCriteria["mother_tongue"] = selectedCriteria.motherTongue.map(item => item.value);
      }
      if (selectedCriteria.domain && selectedCriteria.domain.length > 0) {
        formattedCriteria["domain"] = selectedCriteria.domain.map(item => item.value);
      }
      if (selectedCriteria.religion && selectedCriteria.religion.length > 0) {
        formattedCriteria["religion"] = selectedCriteria.religion.map(item => item.value);
      }
      if (selectedCriteria.cast && selectedCriteria.cast.length > 0) {
        formattedCriteria["cast"] = selectedCriteria.cast.map(item => item.value);
      }
      if (selectedCriteria.occupation && selectedCriteria.occupation.length > 0) {
        formattedCriteria["occupation"] = selectedCriteria.occupation.map(item => item.value);
      }
      if (selectedCriteria.education && selectedCriteria.education.length > 0) {
        formattedCriteria["education"] = selectedCriteria.education.map(item => item.value);
      }


      if (selectedCriteria.income ) {
        console.log('running')
        formattedCriteria["income"] = selectedCriteria.income.value;
      }

      console.log(formattedCriteria , selectedCriteria ,'faisal')
      if (gender === 'M') {
        formattedCriteria.gender = 'F';
      } else {
        formattedCriteria.gender = 'M';
      }

      

      // Add other necessary fields
      formattedCriteria.page = page
      // formattedCriteria.tokan = localStorage.getItem('token');


      // onSubmit(formattedCriteria);
      navigate('/search-result', { state: { searchResult: formattedCriteria } });

    } catch (error) {
      console.log(error)
      toast.error('Something Went Wrong', error);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (profileId) {
      handleProfileSearch(profileId);
    } else {
      handleSearch();
    }
  };
  const handleMaritalStatusChange = (event, id) => {
    const { checked } = event.target;

    setSelectedCriteria((prev) => {
      let updatedMaritalStatus = prev.maritalStatus || [];

      if (id === 7) {
        // When id 7 (e.g., "All") is selected/unselected
        updatedMaritalStatus = checked
          ? maritalStatus.map((status) => status.id) // Select all
          : []; // Clear all
      } else {
        // For any other id
        if (checked) {
          updatedMaritalStatus = [...updatedMaritalStatus, id].filter((item) => item !== 7); // Add id and ensure id 7 is removed
        } else {
          updatedMaritalStatus = updatedMaritalStatus.filter((item) => item !== id); // Remove the id
        }
      }

      return { ...prev, maritalStatus: updatedMaritalStatus };
    });
  };



  const ages = Array.from({ length: 63 }, (_, i) => 18 + i);

  return (
    <div className="col-lg-9 col-12">
      <div className="editProfileBlock">
        <div className="profileDetailsBlock mt-3">
          <div className="basicDetailTlt">
            <p>Search by profile ID</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row justify-content-center align-items-center mb-3 p-4">
              <div className="col-md-6">
                <label className="form-label">Search by profile ID</label>
                <input type="text" className="form-control" placeholder="Enter profile ID" value={profileId} onChange={(e) => setProfileId(e.target.value)} required />
                <button type="submit" className="btn btn-primary formBtn mt-3">Show Me Profile</button>
              </div>
            </div>
          </form>
        </div>

        <div className="profileDetailsBlock mt-3">
          <div className="basicDetailTlt">
            <p>Search by profile criteria</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Age Min</label>
                  <Autocomplete
                    options={ages}
                    renderInput={(params) => <TextField {...params} label="Select Age Min" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, ageMin: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Age Max</label>
                  <Autocomplete
                    options={ages}
                    renderInput={(params) => <TextField {...params} label="Select Age Max" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, ageMax: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Height Min</label>
                  <Autocomplete
                    options={height.map(item => ({ id: item.height_id, label: item.height }))}
                    renderInput={(params) => <TextField {...params} label="Select Height Min" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, heightMin: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Height Max</label>
                  <Autocomplete
                    options={height.map(item => ({ id: item.height_id, label: item.height }))}
                    renderInput={(params) => <TextField {...params} label="Select Height Max" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, heightMax: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <p className="checkTlt">Marital Status</p>
              {maritalStatus.map((status) => (
                <div className="col-md-3" key={status.id}>
                  <div className="form-check">
                    <Checkbox
                      className="form-check-input"
                      checked={
                        selectedCriteria.maritalStatus?.includes(status.id) || false
                      }
                      onChange={(e) => handleMaritalStatusChange(e, status.id)}
                    />
                    <label className="form-check-label" style={{ marginLeft: "8px" }}>
                      {status.status}
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Domain</label>
                  <Autocomplete
                    multiple
                    options={domain.map((item) => ({
                      value: item.id,
                      label: item.domain,
                    }))}
                    // onChange={handleDomainChange}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="Domain" />}
                    onChange={(event, value) => {
                      setSelectedCriteria(prev => ({ ...prev, domain: value }));
                      handleDomainChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Religion</label>
                  <Autocomplete
                    multiple
                    options={religionList.map((item) => ({
                      value: item.id,
                      label: item.religion,
                    }))}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="Religion" />}
                    onChange={(event, value) => {
                      setSelectedCriteria(prev => ({ ...prev, religion: value }));
                      handleReligionChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Caste</label>
                  <Autocomplete
                    multiple
                    options={castList.map((item) => ({
                      value: item.id,
                      label: item.caste,
                    }))}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="Caste" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, cast: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Country</label>
                  <Autocomplete
                    multiple
                    options={country.map((item) => ({
                      value: item.id,
                      label: item.country,
                    }))}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="Country" />}
                    onChange={(event, value) => {
                      setSelectedCriteria(prev => ({ ...prev, country: value }));
                      handleCountryChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">State</label>
                  <Autocomplete
                    multiple
                    options={stateList.map((item) => ({
                      value: item.state_id,
                      label: item.state_name,
                    }))}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="State" />}
                    onChange={(event, value) => {
                      setSelectedCriteria(prev => ({ ...prev, state: value }));
                      handleStateChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <Autocomplete
                    multiple
                    options={cityList.map((item) => ({
                      value: item.id,
                      label: item.city,
                    }))}
                    renderInput={(params) => <TextField {...params} variant="outlined" label="City" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, city: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Annual Income</label>
                  <Autocomplete
                    options={income.map((item) => ({
                      value: item.tbl_income_id,
                      label: item.income_type
                    }))}
                    renderInput={(params) => <TextField {...params} label="Select Annual Income" />}
                    onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, income: value }))}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Education</label>
                    <Autocomplete
                      multiple
                      options={education.map((item) => ({
                        value: item.id,
                        label: item.education,
                      }))}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Education" />}
                      onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, education: value }))}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Profession</label>
                    <Autocomplete
                      multiple
                      options={occupation.map((item) => ({
                        value: item.id,
                        label: item.occupation,
                      }))}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Profession" />}
                      onChange={(event, value) => setSelectedCriteria(prev => ({ ...prev, occupation: value }))}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </div>
                </div>
                <div className="row justify-content-center align-items-center mb-3 p-4">
                  <div className="col-md-6">
                    <button type="submit" className="btn btn-primary formBtn mt-3">Search</button>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
